export default __webpack_public_path__ + "/dist/images/us-flag.2d7f1252d2fc026381a1db1ec6e033f9.svg";